<template >
  
    
    <div>
        <!-- {{usersCount}} {{users}} {{usersOR}} -->
      <template v-if="usersCount>0">
        <div class="divider-text">Ажиллаж буй</div>
        <!-- <div class="text-center">
            <Page @on-change="changePage" :total="usersCount" :page-size="pageSize" size="small"/>
        </div> -->
        <div style="overflow-y: auto">
          <table class="table-god table table-bordered w-full">
            <thead style="font-size: 10px">
              <tr>
                <th style="width: 40px">№</th>
                <th>Хэрэглэгч</th>
                <th>%</th>
                <th style="width: 40px">үзсэн</th>
                <th style="width: 40px">дууссан</th>
                <!-- <th style="width: 40px"><i title="Хэрэглэгчид чатаар илгээх" class="ivu-icon ivu-icon-ios-chatbubbles" style="font-size: 16px; color: rgb(132, 132, 132);"></i></th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(u, i) in users">
                <td>{{i+1}}</td>
                <td style="min-width: 300px">
                   <a role="button" @click="handleUserInfoModal(u.taskId)"> {{u.displayName}}</a>
                  <!-- <Row type="flex">
                    <Col span="3" class="text-center">
                      <a @click="handleUserInfoModal(u.taskId)">
                        <span class="ivu-avatar ivu-avatar-circle ivu-avatar-default ivu-avatar-image">
                          <img :src="u.avator" /></span>
                      </a>
                    </Col>
                    <Col span="19">
                      <div><a @click="handleUserInfoModal(u.taskId)">{{u.displayName}}</a></div>
                      <div class="text-muted">{{u.depart}}<Icon type="ios-arrow-forward"/>{{u.position}}</div>
                    </Col>
                  </Row> -->
                  <!-- <a @click="$emit('showTask', u.taskId)"><Avatar :src="u.avator"></Avatar> {{u.displayName}}</a> -->
                </td>
                <td class="text-center">{{u.perc}}</td>
                <td class="text-center">
                    <!-- <Icon :type="u.seen=='true'||u.seen==true?'md-checkbox-outline':'md-square-outline'" :size="20"/> -->
                    </td>
                <td class="text-center">
                    <!-- <Icon :type="u.isDone=='true'||u.isDone==true?'md-checkbox-outline':'md-square-outline'" :size="20"/> -->
                    </td>
                <!-- <td class="text-center"><button title="Хэрэглэгчид чатаар хавсралт болгож илгээх" @click="sendTask(taskId, u)" type="button" class="ivu-btn ivu-btn-small ivu-btn-info ivu-btn-icon-only"><i class="ivu-icon ivu-icon-ios-chatbubbles" ></i></button></td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      
      <template v-if="usersCountOR>0">
        <div class="divider-text">Бусад оролцогчид</div>
        <div class="text-center">
            <!-- <Page @on-change="changePageOR" :total="usersCountOR" :page-size="pageSizeOR" size="small"/> -->
        </div>
        <div style="overflow-y: auto">
          <table class="table-god table table-bordered w-full">
            <thead style="font-size: 10px">
              <tr>
                <th style="width: 40px">№</th>
                <th>Хэрэглэгч</th>
                <th>%</th>
                <th style="width: 40px">үзсэн</th>
                <th style="width: 40px">дууссан</th>
                <th style="width: 40px"><i title="Хэрэглэгчид чатаар хавсралт болгож илгээх" class="ivu-icon ivu-icon-ios-chatbubbles" style="font-size: 16px; color: rgb(132, 132, 132);"></i></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(u, i) in usersOR">
                <td>{{i+1}}</td>
                <td style="min-width: 300px">
                   <a role="button" @click="handleUserInfoModal(u.taskId)"> {{u.displayName}}</a>
                  <!-- <Row type="flex">
                    <Col span="3" class="text-center">
                      <a @click="handleUserInfoModal(u.taskId)">
                        <span class="ivu-avatar ivu-avatar-circle ivu-avatar-default ivu-avatar-image">
                          <img :src="u.avator" /></span>
                      </a>
                    </Col>
                    <Col span="19">
                      <div><a @click="handleUserInfoModal(u.taskId)">{{u.displayName}}</a></div>
                      <div class="text-muted">{{u.depart}}<Icon type="ios-arrow-forward"/>{{u.position}}</div>
                    </Col>
                  </Row> -->
                </td>
                <td class="text-center">{{u.perc}}</td>
                <td class="text-center">
                    <!-- <Icon :type="u.seen=='true'||u.seen==true?'md-checkbox-outline':'md-square-outline'" :size="20"/> -->
                    </td>
                <td class="text-center">
                    <!-- <Icon :type="u.isDone=='true'||u.isDone==true?'md-checkbox-outline':'md-square-outline'" :size="20"/> -->
                    </td>
                <!-- <td class="text-center"><button title="Хэрэглэгчид чатаар хавсралт болгож илгээх" @click="sendTask(taskId, u)" type="button" class="ivu-btn ivu-btn-small ivu-btn-info ivu-btn-icon-only"><i class="ivu-icon ivu-icon-ios-chatbubbles" ></i></button></td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>
  
</template>

<script>
// import { getPinnedList, getUnPinnedList } from "@/api/project";
import { mapActions } from "vuex";
import { request } from "@/api/all";
export default {
  name: "taskShare",
  props: {
    taskId: {
      type: Number,
      default: () => 0
    },
    drwrW:{
      type: String,
      default: () => '30vw'
    }
  },
  data() {
    return {
      pageCur: 0,
      pageSize: 10,

      pageCurOR: 0,
      pageSizeOR: 10,

      //ready: false,
      users: [],
      usersOR: [],
      usersCount: 0,
      usersCountOR: 0,
    };
  },
  mounted() {
    this.init();
    this.getOtherList();
  },
  methods: {
    ...mapActions(["handleUserInfoModal"]),
    init() {
      //getPinnedList({ id: this.taskId, page: this.pageCur, size: this.pageSize }).
      
      request({
        api: { method: "get", url: "TaskInUser/GetPinnedList" },
        params: { taskId: this.taskId, page: this.pageCur, size: this.pageSize },
        store: this.$store
      }).
      then(res => {
        this.users=res.data.users;
        this.usersCount= res.data.count;
        //this.ready= true;
      });
    },
    getOtherList(){
      //getUnPinnedList({ id: this.taskId, page: this.pageCurOR, size: this.pageSizeOR })
      request({
        api: { method: "get", url: "TaskInUser/GetUnPinnedList" },
        params: { taskId: this.taskId, page: this.pageCurOR, size: this.pageSizeOR },
        store: this.$store
      })
      .then(res => {
        this.usersOR=res.data.users;
        this.usersCountOR= res.data.count;
        //this.ready= true;
      });
    },
    changePage(pg) {
      this.pageCur = pg - 1;
      this.init();
    },
    changePageOR(pg) {
      this.pageCurOR = pg - 1;
      this.getOtherList();
    },
    // sendTask(taskId, u){
    //   this.$Message.success(u.displayName+' -т амжилттай илгээлээ');

    //    this.$store.state.osrCon
    //       .invoke("sendMessageTo", u.userName.toLowerCase(), '', 2, taskId)
    //       .catch(err => console.error(err.toString()));
    // }
  }
};
</script>